export class Questions {
  education_goal: string="";
  primary_bucket: SecondaryBucket[] = new Array<SecondaryBucket>();
  bucket_text: string="";
  bucket_id: string="";
  secondary_bucket_ids:string= "";
  secondary_bucket_value: string;
  secondary_bucket: SecondaryBucket[] = new Array<SecondaryBucket>();
  area_focus_value: string;
  area_focus: AreaFocus[] = new Array<AreaFocus>();
  area_focus_ids:string;
  //online:string="Online";
  online:string="";
  study_type: string="";
  study_state_value:string;
  study_state: StudyState[] = new Array<StudyState>();
  study_state_values:string;
  military_support:boolean=true;
  military_branch: string="";
  military_status: string;
  military_rank: string="";
  mos:string="";
  first_name: string;
  last_name: string;
  zip_code: string;
  state_of_residence: string="";
  phone_number: string;
  check_phone_number:boolean=true;
  email: string;
  password: string;
  cpassword: string;
  site_source:string;
  term:boolean=true;
  uuid: string;
  pageNumber: number;
  uncheckCollegeInfo: string;
  checkCollegeInfo: string="";
  student_message: string;
  message_type: string;
  primary_source: string;
  secondary_source: string;
  searchdata:string;
  passedIn_college_id:string="";
  calmatchSrc:string="";
  subId:string="";
}

export class AreaFocus {
  id: number;
  name: string;
}
export class SecondaryBucket {
  id: number;
  name: string;
}

export class StudyState {
  name:string;
  value:string;
}


// WEBPACK FOOTER //
// ./src/app/models/model.Questions.ts